module.exports = __webpack_public_path__ + "static/innovate-423d9da89b0c69fa7d37cfed85a4af6f.svg";